import { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import NewsList from "@/components/NewsList";
import { api } from "@/lib/api";

export default function Home() {
    const [sectionTitle, setSectionTitle] = useState("أحدث العروض");
    useEffect(() => {
        const apply = (d) => d && d.ads_section_title && setSectionTitle(d.ads_section_title);
        if (typeof window !== "undefined" && window.__siteSettingsPromise) {
            window.__siteSettingsPromise.then(apply).catch(() => {});
        } else {
            api.get("/site-settings").then((r) => apply(r.data)).catch(() => {});
        }
    }, []);

    return (
        <>
            <SEO
                title="أسعار الذهب اليوم في السعودية | سعر جرام الذهب عيار 24 و22 و21 و18"
                description="أسعار الذهب اليوم في المملكة العربية السعودية مباشرة بالريال السعودي – سعر جرام الذهب عيار 24 وعيار 22 وعيار 21 وعيار 18، سعر أونصة الذهب بالدولار، أسعار سبائك الذهب، حاسبة الذهب وحاسبة زكاة الذهب وأحدث أخبار الذهب."
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    name: "أسعار الذهب اليوم",
                    url: "https://asaargold.com",
                    inLanguage: "ar",
                    description:
                        "أسعار الذهب اليوم في السعودية لجميع العيارات بالريال السعودي وسعر الأونصة بالدولار.",
                }}
            />

            {/* BIG ADS */}
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                <div className="mb-8">
                    <p className="text-xs uppercase tracking-widest text-zinc-500 mb-2">
                        عروض وإعلانات
                    </p>
                    <h2 className="font-heading text-3xl md:text-4xl font-bold text-black">
                        {sectionTitle}
                    </h2>
                </div>
                <NewsList category="news" limit={200} />
            </section>
        </>
    );
}
